import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Select, Spin } from 'antd';
import debounce from 'lodash/debounce';
import Axios from '../utils/axios';


function DebounceSelect({ fetchOptions, setSearchItems, selectedFilters, setSelectedFilters, debounceTimeout = 800, ...props }) {
  const [fetching, setFetching] = useState(false);
  const [options, setOptions] = useState([]);
  const fetchRef = useRef(0);


  const debounceFetcher = useMemo(() => {
    const loadOptions = (value) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;
      setOptions([]);
      setFetching(true);
      fetchOptions(value).then((newOptions) => {
        if (fetchId !== fetchRef.current) {
          // for fetch callback order
          return;
        }
        setOptions(newOptions);
        setFetching(false);
      });
    };
    return debounce(loadOptions, debounceTimeout);
  }, [fetchOptions, debounceTimeout]);

  const onChangeSearchFilter = v => {
    // const found = selectedFilters.includes(v);
    // if (found) {
    //   setSelectedFilters(v);
    // }else {
      
    // }
    setSelectedFilters(v);
  }
  const loadAdjustments = () => {
    const names = [];
    const OptionFilters = [];
    
    selectedFilters.forEach(item => {
      if (options.length > 0) {
        const found = options.filter(op => op.value === item);
        if (found.length > 0) {
          names.push(found);
        }else {
          {item !== '' && OptionFilters.push(item)}
        }
      }else {
        {item !== '' && OptionFilters.push(item)}
      }
    });

    const nameLists = names.flatMap(name => name.map(n => n.value));
    const filters = OptionFilters.map(opt => opt.toLowerCase());
    // console.log(nameLists, filters);
    Axios.get(`adjustments/?name=${nameLists}&&options=${filters}`)
    .then(res => res.data)
    .then(res => {
      setSearchItems(res);
    })
    .catch (err => console.log(err))
    .finally (() => {
      setOptions([]);
    })
  };
  
  useEffect(loadAdjustments, [selectedFilters])
  
  return (
    <Select
      onSearch={debounceFetcher}
      notFoundContent={fetching ? <Spin size="small" /> : null}
      {...props}
      options={options}
      onChange={onChangeSearchFilter}
      dropdownStyle={{visibility: options.length > 0 ? true: false}}
    />
  );
};


export default DebounceSelect;